module.exports = __webpack_public_path__ + "img/name-box-new.4015b5ca.png";